export default __webpack_public_path__ + "static/media/punta-cana-international-airport.fdcd0de7.png";